import React from "react";
import { useTranslation } from "react-i18next";
import { LoginPagesLayout } from "@features/login/LoginPagesLayout";
import { ShowcasePageTitle } from "@components";
import { SignupPageForm } from "./components/SignupPageForm";
import { SignupPageLoginQuestion } from "./components/SignupPageLoginQuestion";

export const SignupPage = () => {
  const { t } = useTranslation();
  return (
    <LoginPagesLayout>
      <ShowcasePageTitle
        title={t("signupPage.header.title")}
        subtitle={t("signupPage.header.subtitle")}
      />

      <SignupPageForm />

      <SignupPageLoginQuestion />
    </LoginPagesLayout>
  );
};
